var _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerBorderOutlineCircleWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.499 5C24.4025 5 29.9988 10.5966 29.999 17.5C29.999 24.4036 24.4026 30 17.499 30C10.5956 29.9998 4.99902 24.4035 4.99902 17.5C4.9992 10.5967 10.5957 5.00018 17.499 5Z",
    stroke: "#F79B0F",
    strokeWidth: 1.66667
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0.833008C26.7047 0.833008 34.167 8.29525 34.167 17.5C34.167 26.7047 26.7047 34.167 17.5 34.167C8.29525 34.167 0.833008 26.7047 0.833008 17.5C0.833008 8.29525 8.29525 0.833008 17.5 0.833008Z",
    stroke: "#F79B0F",
    strokeWidth: 1.66667
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4993 15.417V18.7503L19.5827 20.0003M17.4993 11.667C13.5873 11.667 10.416 14.8383 10.416 18.7503C10.416 22.6623 13.5873 25.8337 17.4993 25.8337C21.4114 25.8337 24.5827 22.6623 24.5827 18.7503C24.5827 14.8383 21.4114 11.667 17.4993 11.667ZM17.4993 11.667V9.16699M15.8327 9.16699H19.166M24.4402 12.1604L23.1902 10.9104L23.8152 11.5354M10.5585 12.1604L11.8085 10.9104L11.1835 11.5354",
    stroke: "#F79B0F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerBorderOutlineCircleWarning);
export default __webpack_public_path__ + "static/media/timer-border-outline-circle-warning.73b08bc85d049a7df74afe8b20a05997.svg";
export { ForwardRef as ReactComponent };